import { useQuery } from '@tanstack/react-query';
import Fetch from '../../../../../../core/util/core/Fetch';
import config from '../../../../../config/config';
import { getUserSession } from '../../../../../util/core/Session';
import { chooseProfileFilter } from '../../../../../helpers/chooseProfileFilter';

const useCities = (enabled = true) => {
    const session = getUserSession();
    const profileFilter = chooseProfileFilter();

    const profile = session.user.application_profile_id;

    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    let filters = {
        core_application_instance_id: null
    };

    if (Object.keys(profileFilter).length > 0 && !isAdm) {
        filters = {
            ...profileFilter
        }
    } else if (session.user.application_instance_id && !isAdm) {
        filters = {
            core_application_instance_id: session.user.application_instance_id
        }
    }

    return useQuery({
        queryKey: ['cities-dashboard-ciha'],
        queryFn: async () => {
            const cities = await Fetch.post(
                config.endpoints.backend +
                'governanceroom/clientscities/getall',
                {
                    filters
                }
            );

            const citiesMapped = cities.map((city) => ({
                label: city.city_name,
                value: city.city_id,
                governance_room_client_city_id: city.id,
                governance_room_geo_city_id: city.governance_room_geo_city_id,
            }));

            const citiesNotRepeated = new Set();
            const citiesFiltered = citiesMapped.filter((city) => {
                if (citiesNotRepeated.has(city.value)) {
                    return false;
                }
                citiesNotRepeated.add(city.value);
                return true;
            });

            return citiesFiltered || [];
        },
        enabled
    });
};

export default useCities;
